import { render, staticRenderFns } from "./StatisticList.vue?vue&type=template&id=049c7f36&scoped=true&"
import script from "./StatisticList.vue?vue&type=script&lang=js&"
export * from "./StatisticList.vue?vue&type=script&lang=js&"
import style0 from "./StatisticList.vue?vue&type=style&index=0&id=049c7f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c7f36",
  null
  
)

export default component.exports